/**
 * These functions are copied from Material UI:
 * https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/useForkRef.ts
 * https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/setRef.ts
 */

import * as React from 'react';

export function setRef<T>(
    ref: React.MutableRefObject<T | null> | ((instance: T | null) => void) | null | undefined,
    value: T | null,
): void {
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref) {
        ref.current = value;
    }
}

export default function useForkRef<InstanceA, InstanceB>(
    refA: React.Ref<InstanceA> | null | undefined,
    refB: React.Ref<InstanceB> | null | undefined,
): React.Ref<InstanceA & InstanceB> | null {
    /**
     * This will create a new function if the ref props change and are defined.
     * This means react will call the old forkRef with `null` and the new forkRef
     * with the ref. Cleanup naturally emerges from this behavior.
     */
    return React.useMemo(() => {
        if (refA == null && refB == null) {
            return null;
        }
        return (refValue) => {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
}